import { Button } from "primereact/button";

const ClienteActions = ({ 
    step,
    rowData, 
    onSeleccionar,
    onSelectDatos, 
    onSelectDeuda, 
    onSelectTickets, 
    onSelectVenta, 
    onSincronizarCliente,
    syncingCodigo,
    onActualizarCliente,
    loadingCotizacion,
    tipoDocumento,   
}) => {
    const codigo = rowData?.codigo || rowData?.cliente?.codigo;
    const isSyncing = syncingCodigo && codigo === syncingCodigo;

    return ( step === 'cotizacion' ? (
            // cabecera cotizacion
            (tipoDocumento !== 'nota-venta' ? (
                // boletas y facturas
                <div className="flex flex-column gap-2">
                    <div className="flex gap-2 justify-content-left">
                        {onSelectDatos && <Button tooltip="Datos" tooltipOptions={{ position: 'top' }} icon="pi pi-info" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Usuario" onClick={() => onSelectDatos(rowData)} />}
                        {onSelectDeuda && <Button tooltip="Deuda" tooltipOptions={{ position: 'top' }} icon="pi pi-exclamation-triangle" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Alerta" onClick={() => onSelectDeuda(rowData)} disabled />}
                        {onSelectTickets && <Button tooltip="Tickets" tooltipOptions={{ position: 'top' }} icon="pi pi-lock" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Bloquear" onClick={() => onSelectTickets(rowData)} />}
                        {onSelectVenta && <Button tooltip="Ventas" tooltipOptions={{ position: 'top' }} icon="pi pi-star" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Favorito" onClick={() => onSelectVenta(rowData)} />}
                        {onActualizarCliente  && <Button tooltip="Actualizar" tooltipOptions={{ position: 'top' }} icon={loadingCotizacion ? "pi pi-spin pi-spinner" : "pi pi-sync"} className="p-button-rounded p-button-success  p-button-sm" aria-label="Refrescar" onClick={() => onActualizarCliente(rowData)} />}
                    </div>
                </div>
            ) : (
                // nota de venta
                <div className="flex flex-column gap-2">
                    <div className="flex gap-2 justify-content-left">
                        {onSelectDatos && <Button tooltip="Datos" tooltipOptions={{ position: 'top' }} icon="pi pi-info" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Usuario" onClick={() => onSelectDatos(rowData)} />}
                        {onSelectDeuda && <Button tooltip="Deuda" tooltipOptions={{ position: 'top' }} icon="pi pi-exclamation-triangle" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Alerta" onClick={() => onSelectDeuda(rowData)} />}
                    </div>
                </div>
            ))
        ) : (
            //tablero clientes
            (tipoDocumento !== 'nota-venta' ? (
                // boletas y facturas
                <div className="flex flex-column gap-2">
                    <div className="flex gap-2 justify-content-center">
                        {onSeleccionar && (<Button icon="pi pi-check" className="p-button-rounded p-button-info  p-button-sm" tooltip="Seleccionar"tooltipOptions={{ position: 'top' }} aria-label="Seleccionar" onClick={() => onSeleccionar(rowData)}/>)}
                        {onSelectDatos && <Button tooltip="Datos" tooltipOptions={{ position: 'top' }} icon="pi pi-info" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Usuario" onClick={() => onSelectDatos(rowData)} />}
                        {onSelectDeuda && <Button tooltip="Deuda" tooltipOptions={{ position: 'top' }} icon="pi pi-exclamation-triangle" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Alerta" onClick={() => onSelectDeuda(rowData)} />}
                    </div>
                    <div className="flex gap-2 justify-content-center">
                        {onSelectTickets && <Button tooltip="Tickets" tooltipOptions={{ position: 'top' }} icon="pi pi-lock" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Bloquear" onClick={() => onSelectTickets(rowData)} />}
                        {onSelectVenta && <Button tooltip="Ventas" tooltipOptions={{ position: 'top' }} icon="pi pi-star" className="p-button-rounded p-button-primary  p-button-sm" aria-label="Favorito" onClick={() => onSelectVenta(rowData)} />}
                        {onSincronizarCliente && <Button tooltip="Sincronizar" tooltipOptions={{ position: 'top' }} icon={isSyncing ? "pi pi-spin pi-spinner" : "pi pi-refresh"} className="p-button-rounded p-button-success  p-button-sm" aria-label="Refrescar" onClick={() => onSincronizarCliente(rowData)} />}
                    </div>
                </div>
            ) : (
                // nota de venta
                <div className="flex flex-column gap-2">
                    <div className="flex gap-2 justify-content-center">
                        {onSeleccionar && (<Button icon="pi pi-check" className="p-button-rounded p-button-info  p-button-sm" tooltip="Seleccionar"tooltipOptions={{ position: 'top' }} aria-label="Seleccionar" onClick={() => onSeleccionar(rowData)}/>)}
                    </div>
                </div>
            ))
        )
    );
};

export default ClienteActions;